/**
 * 글 날짜 한 줄 — "2026.09.04". 데스크톱 시안의 표기다.
 * @description 보는 사람의 시간대가 아니라 UTC 로 찍는다 — 서버와 브라우저가 같은 문자열을
 *   내야 하이드레이션이 어긋나지 않는다(콜랩 날짜와 같은 이유).
 */
const formatter = new Intl.DateTimeFormat("en-CA", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  timeZone: "UTC",
});

export function formatPostDate(iso: string): string {
  return formatter.format(new Date(iso)).replace(/-/g, ".");
}
